module.exports = __webpack_public_path__ + "static/media/Plumbing.bc7572f2.png";